import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { FrameContext } from "../../contexts/FrameContext";
import firebaseApi from "../../apis/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";

const AppointmentJoin = () => {
    const { scheduleId } = useParams();
    const {companyId, agentId} = React.useContext(FrameContext);
    const [schedule, setSchedule] = React.useState();
    let history = useHistory();

    React.useEffect(() => {
        if (!companyId || !scheduleId) return;
        firebaseApi.getAgentSchedule(companyId, scheduleId, data => {
            if (!data.exists) {
                history.push(`/agent`);
            }
            setSchedule({ ...data.data(), id: data.id })
        });
    }, [companyId, scheduleId]);

    const onCancelClick = () => {
        history.push(`/appointment/${scheduleId}/cancel`);
    }

    const onRescheduleClick = () => {
        history.push(`/appointment/${scheduleId}/reschedule`);
    }

    if (!schedule) return null;

    return (
        <div className="cts-scheduled">
            <h2>Welcome!</h2>
            <div>
                You're scheduled for a virtual<br />
                appointment with {schedule.name}:
            </div>
            <hr />
            <div className="cts-schedule-date-container">
                <div className="cts-calendar-container">
                    <i className="fas fa-calendar-star" />
                </div>
                <div className="cts-date-container">
                    {/* Today<br /> */}
                    <b>{dateHelpers.getScheduleDay(new Date(schedule.schedule.startTime * 1000))}</b><br />
                    {dateHelpers.getTimeString(new Date(schedule.schedule.startTime * 1000))} - {dateHelpers.getTimeString(new Date(schedule.schedule.endTime * 1000), true)}
                </div>
            </div>
            <hr />
            <div className="cts-schedule-buttons">
                <button type="button" className="btn btn-black"><i className="far fa-plus" /> Join the chat</button>
                <div className="cts-split">
                    <button type="button" onClick={onRescheduleClick} className="btn-secondary">Reschedule</button>
                    <button type="button" onClick={onCancelClick} className="btn-secondary">Cancel Now</button>
                </div>
            </div>
        </div>
    )
}

export default AppointmentJoin;